import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CargoService } from 'src/app/service/cargo.service';
import { DepartamentoService } from 'src/app/service/departamento.service';
import { Departamento } from '../departamento/departamento';
import { Cargo } from './cargo';

@Component({
  selector: 'app-cargo-form',
  templateUrl: './cargo-form.component.html',
  styleUrls: ['./cargo-shared.scss'],
})
export class CargoFormComponent implements OnInit {

  formulario: FormGroup;
  carregando = false;
  departamentos: Departamento[] = [];

  constructor(
    private fb: FormBuilder,
    private service: CargoService,
    private departamentoService: DepartamentoService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarForm();
    this.carregarDepartamentos();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregar(+id);
    }
  }

  montarForm(item?: Cargo) {
    this.formulario = this.fb.group({
      id: [item?.id ?? null],
      nome: [item?.nome ?? '', Validators.required],
      descricao: [item?.descricao ?? ''],
      departamentoId: [item?.departamentoId ?? null, Validators.required],
      ativo: [item?.ativo ?? true],
    });
  }

  carregarDepartamentos() {
    this.departamentoService.listarAtivos().subscribe(lista => this.departamentos = lista ?? []);
  }

  carregar(id: number) {
    this.carregando = true;
    this.service.buscarPorId(id).subscribe(item => {
      this.montarForm(item);
      this.carregando = false;
    }, () => {
      this.carregando = false;
      this.snackBar.open('Cargo não encontrado.', 'ERRO', { duration: 2500 });
      this.voltarConsulta();
    });
  }

  submit() {
    if (this.formulario.invalid) {
      return;
    }
    this.service.salvar(this.formulario.value).subscribe(() => {
      this.snackBar.open('Cargo salvo com sucesso.', 'OK', { duration: 2500 });
      this.voltarConsulta();
    }, err => this.snackBar.open(err.error?.message ?? 'Erro ao salvar.', 'ERRO', { duration: 3000 }));
  }

  limpar() {
    this.router.navigate(['/cargo/form']);
    this.montarForm();
  }

  voltarConsulta() {
    this.router.navigate(['/cargo/consulta']);
  }
}
